import {
  VaccineVirusTypeModel,
  IVaccineVirusTypeModel,
} from '@common/models/VaccineVirusTypeModel';
import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';
import { ServiceHelper } from '../serviceHelper';
import { ServiceMethodOptions } from '../types';

export class VaccineVirusTypeService {
  private static baseUrl: string = '/api/vaccinevirustype';

  static tags = {
    vaccineVirusType: 'vaccineVirusType',
  };

  static upsertVaccineVirusType = (
    data: IVaccineVirusTypeModel,
    options?: ServiceMethodOptions,
  ): Promise<VaccineVirusTypeModel> => {
    return trackPromise(
      new Promise<IVaccineVirusTypeModel>((resolve, reject) => {
        http(`${this.baseUrl}`)
          .post<IVaccineVirusTypeModel>(data)
          .then((response) => {
            ServiceHelper.showSuccess('Vaccine Virus Type updated.', options);
            resolve(new VaccineVirusTypeModel(response));
          })
          .catch((err) => {
            ServiceHelper.showError(
              'Failed to update Vaccine Virus Type.',
              options,
            );
            reject(err);
          });
      }),
      this.tags.vaccineVirusType,
    );
  };

  static deleteVaccineVirusType = (
    vaccineVirusTypeId: number,
    options?: ServiceMethodOptions,
  ): Promise<boolean> => {
    return trackPromise(
      new Promise<boolean>((resolve, reject) => {
        http(`${this.baseUrl}/${vaccineVirusTypeId}`)
          .delete()
          .then(() => {
            ServiceHelper.showSuccess(
              'Vaccine Virus Type has been deleted.',
              options,
            );
            resolve(true);
          })
          .catch((err) => {
            ServiceHelper.showError(
              'Failed to delete Vaccine Virus Type.',
              options,
            );
            reject(err);
          });
      }),
      this.tags.vaccineVirusType,
    );
  };
}
